// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"470c3363","732":"8f27fcbf","977":"aa74253f"}[chunkId] + ".chunk.js";
};